import Validator from './validator.js';
import Debounce from '../utils/debounce';
import { hide } from '../utils/helpers.js';

export default class FormValidation {

  validators = {};

  constructor(initValidation = false) {
    const forms = document.querySelectorAll("form.needs-validation");
    if (forms.length && initValidation) {
      this.initValidators();
    }
  }

  /**
   * This function iterate through solodev.validatorInitConfig
   * and create instances of Validator class.
   */
  initValidators = function () {
    if (window.solodev.validatorInitConfig) {
      window.solodev.validatorInitConfig.forEach((config) => {
        const validator = new Validator(
          "#" + config.formId,
          config.rules,
          config.options
        );
        if (typeof config.setup === "function") {
          config.setup(validator);
        }

        const stateField = document.getElementById(config.formId + '_state');
        if (stateField) {
          this.updateStateField(validator);
        }

        const enterpriseForm = document.getElementById('enterprise_create'),
        joinForm = document.getElementById('join'),
        siteForm = document.getElementById('cms') || document.getElementById('external') || document.getElementById('static'),
        orgForm = document.getElementById('organization'),
        deploymentInstallForm = document.getElementById('deployment_install'),
        captchaInput = document.getElementsByClassName('for-captcha')[0],
        passwordInput = document.getElementById('join_password'),
        formSpecPhone = document.getElementById('form_spec_phone'),
        categoryCheckbox = document.querySelectorAll('.js-category-input');

        if (enterpriseForm || joinForm) {
          this.validateUsername(validator);
          this.validateEmail(validator);
        }
        if (captchaInput) {
          this.captcha(validator, captchaInput);
        }
        if (deploymentInstallForm) {
          this.validateCMSName(validator);
        }
        if (passwordInput) {
          this.passwordInput = passwordInput;
          this.hideHelperErrorMsg(validator);
        }
        if (formSpecPhone) {
          validator.addFieldOption('form_spec[phone]', 'trim', true);
        }
        if (categoryCheckbox.length) {
          this.categoryCheckbox = categoryCheckbox;
          this.catalogCategory(validator);
        }
        if (siteForm) {
          this.validateWebsiteAvailability(validator);
        }
        if (orgForm) {
          this.validateOrganizationAvailability(validator);
        }

        this.validators[config.formId] = validator;
        window.solodev.formValidators = this.validators;
      });
    }
  };

  /**
   * Return instance of validator by form id.
   * @param {String} formId
   * @return {Validator|null}
   */
  getValidator = function (formId) {
    return this.validators[formId] || null;
  };

  /**
   *
   * @param {HTMLInputElement} inputFile
   * @param {Function || Null} action
   * @return {Void}
   * @todo It would be nice if we can get this to work with a red message below the input file using the Validator instead of the alert.
   */
  imageExtensionChecker = function (inputFile, action = null) {
    const allowedImageExtensions = ["jpg", "jpeg", "png", "svg"];
    inputFile.addEventListener("change", (e) => {
      var ext = inputFile.value
        .substring(e.target.value.lastIndexOf(".") + 1)
        .toLowerCase();
      if (
        inputFile.files &&
        inputFile.files[0] &&
        allowedImageExtensions.includes(ext)
      ) {
        if (action) {
          action();
        }
      } else {
        inputFile.value = null;
        alert("Only image files (JPEG, PNG or SVG) are allowed.");
      }
    });
  };

  /**
   *
   * Update state field based on the country field.
   * If user chooses US the state field will be a select.
   * If user chooses a different country, the State field will be an input type="text"
   * and the required state will be removed.
   *
   * @param {String} formId
   * @return {void}
   */
  updateStateField(validator) {
    const formId = validator.form.getAttribute('id');
    const countryField = document.getElementById(formId + '_country');
    const stateFieldLabel = document.querySelector('label[for="'+ formId +'_state"]');
    const { submitBtn } = validator;

    if (countryField) {
      countryField.addEventListener('change', (e) => {

        if (submitBtn) {
          submitBtn.setAttribute('disabled', 'disabled');
        }

        const form = e.target.closest('form'),
        data = {};
        data[e.target.getAttribute('name')] = e.target.value;

        $.ajax({
          url : form.getAttribute('action'),
          type: form.getAttribute('method'),
          data : data,
          success: function(html) {
            const formId = validator.form.getAttribute('id');
            var newStateField = $(html).find('#'+formId +'_state');

            $('#'+formId +'_state').replaceWith(newStateField);

            validator.initField(formId +'[state]');

            // Update rules.
            if (e.target.value === 'US') {
              validator.addFieldValidation(formId + '[state]', 'notBlank', {
                'message': 'This value should not be blank.'
              });
              stateFieldLabel.classList.add('required');
            } else {
              validator.removeFieldValidation(formId +'[state]');
              stateFieldLabel.classList.remove('required');
              validator.clearError(formId +'[state]');
            }

            if (submitBtn && submitBtn.hasAttribute('disabled')) {
              submitBtn.removeAttribute('disabled');
            }
          }
        });
      });
    }
  }

  /**
   * Checks if username already exists when signing up
   * for solodev account
  */
  validateUsername(validator) {
    const formId = validator.form.getAttribute('id');
    const debounce = new Debounce(function (value, resolve, reject) {
      if (value) {
        $.ajax({
          url: "/join/check-username.json",
          data: {
            value: value.toLowerCase()
          },
          type: "GET",
          success: function (response) {
            if (!response.isAvailable) {
              const field = validator.getField(formId+'[name]');
              const parentElement = field.el.closest('.js-name');
              if (parentElement?.classList.contains('d-none')) {
                parentElement?.classList.remove('d-none');
              }
              return reject('Given namespace is already in use');
            } else {
              return resolve();
            }
          }
        });
      } else {
        resolve();
      }
    }, 500);
    validator.addFieldValidation(formId+'[name]', debounce.call());
    validator.addFieldValidation(formId+'[name]', 'length', {
      min: 4,
      max: 50,
      maxMessage: 'This value is too long. It should have 50 characters or less.',
      minMessage: 'This value is too short. It should have 4 characters or more.',
    });
  }

  validateCMSName(validator) {
    const formId = validator.form.id;
    const { nameAvailableUrl } = validator.form.dataset;

    validator.addFieldValidation(formId+'[name]', (value, resolve, reject) => {
      if (value) {
        window.theForm = validator.form;
        const domainFieldName = `${formId}[my_domain_id]`;
        const domainFieldSelector = `[name="${domainFieldName}"]`;
        const domainField = validator.form.querySelector(domainFieldSelector);

        if (!domainField) {
          resolve();
          return;
        }

        const domainFieldValue = domainField.value;
        if (!domainFieldValue) {
          resolve();
          return;
        }

        $.ajax({
          url: nameAvailableUrl,
          type: 'post',
          data: {
            name: value,
            domain_id: domainFieldValue,
          },
          success() {
            resolve();
          },
          error(err) {
            reject(err.responseJSON.error);
          }
        });
      } else {
        resolve();
      }
    });
  }
  /**
   * Checks if email already exists when signing up
   * for solodev account
  */
  validateEmail(validator) {
    const formId = validator.form.getAttribute('id');
    const debounce = new Debounce(function (value, resolve, reject) {
      if (value) {
        $.ajax({
          url: "/join/check-email.json",
          data: {
            value: value.toLowerCase(),
          },
          type: "GET",
          success: function (response) {
            if (!response.isAvailable) {
              const field = validator.getField(formId+'[email]');
              const parentElement = field.el.closest('.js-email');
              if (parentElement?.classList.contains('d-none')) {
                parentElement?.classList.remove('d-none');
              }
              return reject('Given email is already in use');
            } else {
              return resolve();
            }
          }
        });
      } else {
        resolve();
      }
    }, 500);
    validator.addFieldValidation(formId+'[email]', debounce.call());
  }

  /**
   * Checks if website name already exists
  */
  validateWebsiteAvailability(validator) {
    const form = validator.form,
    formId = form.getAttribute('id');
    const debounce = new Debounce(function (value, resolve, reject) {
      let siteNameValue = value;

      const domain = form.querySelector('.site_domain');
      if (domain) {
        const domainSelected = domain.options[domain.options.selectedIndex] || null;
        const domainValue = domainSelected ? domainSelected.innerText.trim() : '';
        siteNameValue = value ? value + '.'  + domainValue : domainValue;
      }

      if (siteNameValue) {
        const checkWebsiteUrl = form.querySelector('.site_name').getAttribute('data-url');
        $.ajax({
          url: checkWebsiteUrl,
          data: {
            value: siteNameValue,
          },
          type: "GET",
          success: function (response) {
            if (!response.isAvailable) {
              return reject('A website with that name already exists.');
            } else {
              return resolve();
            }
          }
        });
      } else {
        resolve();
      }
    }, 500);
    validator.addFieldValidation(formId+'[name]', debounce.call());
  }

  /**
   * Checks if organization name already exists
  */
  validateOrganizationAvailability(validator) {
    const formId = validator.form.getAttribute('id');
    const debounce = new Debounce(function (value, resolve, reject) {
      if (value) {
        $.ajax({
          url: "/orgs/check-organization.json",
          data: {
            value: value.toLowerCase(),
          },
          type: "GET",
          success: function (response) {
            if (!response.isAvailable) {
              return reject('An organization with that name already exists.');
            } else {
              return resolve();
            }
          }
        });
      } else {
        resolve();
      }
    }, 500);
    validator.addFieldValidation(formId+'[title]', debounce.call());
  }

  captcha(validator, input) {
    const { publicKey } = input.dataset;

    validator.addFormValidation((resolve) => {
      grecaptcha.ready(function() {
        grecaptcha.execute(publicKey, { action: 'join' }).then((token) => {
          input.value = token;
          resolve();
        });
      });
    });
  }

  hideHelperErrorMsg(validator) {
    const fieldName = this.passwordInput.getAttribute('name');
    const fieldId = this.passwordInput.getAttribute('id');
    this.passwordInput.addEventListener('keydown', () => {
      if (validator.hasError(fieldName)) {
        hide(document.querySelector('#'+ fieldId + '_help'));
      }
    });
  }

  catalogCategory(validator) {
    const formId = validator.form.getAttribute('id');
    const formValidator = this.getValidator(formId);
    if (formValidator) {
      this.getValidator(formId).addEventListener('form-submit', () => {
        this.categoryCheckbox.forEach((node) => {
          node.removeAttribute('disabled');
        });
      });
    }
  }
}
